// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bgtvlegolklbpvamnveq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJndHZsZWdvbGtsYnB2YW1udmVxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg4ODQwOTAsImV4cCI6MjA2NDQ2MDA5MH0.cJsJbez_VSaOqWcMzWmo1iZPyby2pegd-Y6zwa2Ls4U";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});